export default __webpack_public_path__ + "static/media/sunspots.fa508d05.svg";